import React from 'react';
import { Helmet } from 'react-helmet-async';

const Me = () => {

  const personData = {
    "@context": "https://schema.org/",
    "@type": "Person",
    "name": "Martin Kuchar",
    "url": "https://www.beehive-techhub.ca/",
    "sameAs": [
      "https://www.linkedin.com/in/kucharmartin",
      "mailto:kucharmartin0@gmail.com",
      "tel:+12365120228"
    ]
  };

  return (
    <div className="app">
      <Helmet>
        <title>Martin Kuchar Resume - Software Development</title>
        <script type="application/ld+json">{JSON.stringify(personData)}</script>
      </Helmet>
      <div className="my-history-section-wrapper">
        <div className="my-history-section">
          <div className="my-history-content">
            <div className="my-history-card-section">
              <img src={process.env.PUBLIC_URL + '/assets/images/martin-picture.png'} alt="Profile" />
              <h2>Martin Kuchar</h2>
              <div>
                <p>
                  As a result-oriented and proactive professional with a strong work ethic,
                  I am committed to staying up to date with technology trends.
                  I am excited to explore opportunities that allow me to leverage my expertise to create impactful solutions.
                </p>
                <p>Thank you for your interest.</p>
              </div>
            </div>
            <div>
              <div className="section-title">Experience</div>
              <ul>
                <li>
                  <b><strong>Senior Software Engineer | Forward Deployed Engineer</strong> at ElasticPath, Vancouver, BC, Canada (Jan 2026 - Present)</b>
                  <div className="position-description">
                    - Work on custom engineering solution with the major client.
                  </div>
                </li>
                <li>
                  <b><strong>Project Lead - Software Engineer</strong> at QuoteMedia, Inc., Vancouver, BC, Canada (Apr 2024 - Dec 2025)</b>
                  <div className="position-description">
                    - Take ownership of the authentication service, a core application used by tens of thousands of users daily, by diving deep into the full development cycle from design to deployment.
                    <br />
                    - Collaborate with multiple teams, providing technical support, and mentorship to new developers.
                    <br />
                    - Engineered a fault-tolerant caching layer with proactive fault detection and seamless failover to maintain service continuity during node disruptions. Achieving a 99.9% uptime and eliminating major outages since deployment.
                    <br />
                    - Drove the migration of the services to OCI to enhance system scalability and performance.
                  </div>
                </li>
                <li>
                  <b><strong>Project Lead - Software Engineer</strong> at QuoteMedia, Inc., Vancouver, BC, Canada (Sep 2022 - Apr 2024)</b>
                  <div className="position-description">
                    - Designed the system architecture and owned the end-to-end development of a stock market analysis Excel add-in, transforming a proof of concept into a fully commercially deployed product in production used by hundreds of clients in daily trading workflows.
                    <br />
                    - Analyzed product requirements, created technical designs, and distributed tasks among developers to ensure maintainable delivery.
                    <br />
                    - Demonstrated project management skills by overseeing the project, prioritizing scalability, long-term maintainability, and simplicity.
                  </div>
                </li>
                <li>
                  <b><strong>Software Engineer</strong> at QuoteMedia, Inc., Vancouver, BC, Canada (Mar 2021 - Sep 2022)</b>
                  <div className="position-description">
                    - Contributed to the development, maintenance, and modification of web microservices within the company's microservice system.
                    <br />
                    - Engaged in code review and peer review meetings to provide constructive feedback and improve the overall design and code quality.
                    <br />
                    - Applied expertise in Microservices, JavaServer Pages (JSP), Hibernate, Spring Boot, Java, and Spring Framework to deliver robust and scalable solutions.
                  </div>
                </li>
                <li>
                  <b><strong>Service/Web Engineer</strong> at Rosim AS, Oslo, Norway (Jun 2018 - Nov 2019)</b>
                  <div className="position-description">
                    - Generated, maintained, and presented comprehensive reports to customers detailing data and observations; also recommending
                    appropriate courses of action.
                    <br />
                    - Maintained a website and spreadsheet application to track and manage all the projects using Monday.com.
                  </div>
                </li>
              </ul>
              <div className="section-title">Academic profile</div>
              <ul>
                <li>
                  <b><strong>Diploma Course, Mobile App and Web Development</strong> at CICCC - Cornerstone International Community College of Canada (Jan 2020 - Jan 2021)</b>
                </li>
                <li>
                  <b><strong>Master's Degree, Environmental Engineering Technology/Environmental Technology</strong> at University of Zilina (2013 - 2018)</b>
                  <div className="position-description">
                    - Successfully graduated Master’s degree. Gained theoretical knowledge of energy systems, renewable energy sources, and HVAC projection.
                    <br />
                    - Final thesis consisted of researching the effects of the airflow in the boiler. Used the advanced PIV method to measure the speed and direction of air. These factors influence the fluency of combustion, production of emission. The solution (airflow division) was successful, optimizing combustion in the boiler, reducing the production of emission, and saving energy.
                  </div>
                </li>
                <li>
                  <b><strong>Environmental Engineering Technology/Environmental Technology</strong> at Czech Technical University in Prague (2016 - 2017)</b>
                  <div className="position-description">
                    - Successfully completed the Erasmus program. Was an exchange student through the Erasmus program in Prague, where attended the Czech Technical University of Prague. Spent one semester there. Studied different software development languages such as Python, measuring systems in environmental technic, and HVAC programs. It was a great opportunity to gain experience in the software engineering fields.
                  </div>
                </li>
              </ul>
              <div className="section-title">Licenses & Certifications</div>
              <ul>
                <li>
                  <b><strong>Understanding Financial Markets</strong> (Coursera, Issued Sep 2022, Credential ID: PNBHD9FZB2EN)</b>
                </li>
              </ul>
              <div className="section-title">Volunteering</div>
              <ul>
                <li>
                  <b><strong>Coding Mentor/Teaching Assistant</strong> at CICCC - Cornerstone International Community College of Canada (Sep 2020 - Feb 2021)</b>
                  <div className="position-description">
                    - Reviewed student's code, graded assignments, and provided feedback with specific advice to their work.
                    <br />
                    - Mentored students to learn and improve their programming and object-oriented thinking.
                  </div>
                </li>
              </ul>
            </div>
            <div className="my-history-card-section">
              <h2>Skills</h2>
              <ul>
                <li>
                  <strong>Programming Languages:</strong>
                  <br />
                  - Java, JavaScript, SQL, Swift, Objective-C, Python.
                </li>
                <li>
                  <strong>Backend Development:</strong>
                  <br />
                  - Microservices, Spring Boot, Spring Framework, Hibernate, RabbitMQ, Hazelcast, Redis, InfluxDB, Vault.
                </li>
                <li>
                  <strong>Web Development:</strong>
                  <br />
                  - React.js, Node.js & Express, Webpack, HTML5 & CSS3.
                </li>
                <li>
                  <strong>Version Control:</strong>
                  <br />
                  - Git (Bitbucket, GitHub)
                </li>
                <li>
                  <strong>Cloud computing:</strong>
                  <br />
                  - OCI, AWS (Lambda, API Gateway, CloudWatch, S3, Amplify), Cloudflare
                </li>
                <li>
                  <strong>Other Skills:</strong>
                  <br />
                  - Object-Oriented Programming (OOP) principles, RESTful APIs, Web services, Microservice architecture,
                  MVC architecture, Design patterns, Software debugging and troubleshooting, Problem-solving and analytical thinking
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Me;
